import { createSlice } from '@reduxjs/toolkit';
import businessService from '../../services/businessService';
import Toast from '../../components/shared/Toast';
import storageHelper from '../../utils/storageHelper';

const initialState = {
  businessIdea: null,
  analysis: null,
  isLoading: false,
  error: null
};

const businessIdeaSlice = createSlice({
  name: 'businessIdea',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setBusinessIdeaAnalysis: (state, action) => {
      state.businessIdea = action.payload.businessIdea;
      state.analysis = action.payload.analysis;
    },
    resetAnalysis: () => {
      return initialState;
    }
  }
});

// Export actions
export const { setLoading, setError, setBusinessIdeaAnalysis, resetAnalysis } = businessIdeaSlice.actions;

// Async thunk action
export const fetchBusinessIdeaAnalysis = (businessId) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(null));

    const response = await businessService.getBusinessIdeaAnalysis(businessId);
    dispatch(setBusinessIdeaAnalysis(response));
  } catch (err) {
    console.error('Analysis fetch error:', err);
    if (err.status === 401) {
      storageHelper.remove('authToken');
      Toast.error('Session expired. Please login again.');
    }
    dispatch(setError(JSON.parse(err.message).error || 'Failed to fetch business idea analysis'));
    Toast.error(JSON.parse(err.message).error || 'Failed to fetch business idea analysis');
  } finally {
    dispatch(setLoading(false));
  }
};

// Selectors
export const selectBusinessIdea = (state) => state.businessIdea.businessIdea;
export const selectAnalysis = (state) => state.businessIdea.analysis;
export const selectIsLoading = (state) => state.businessIdea.isLoading;
export const selectError = (state) => state.businessIdea.error;

export default businessIdeaSlice.reducer;
